import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-631974b8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "text"
  }, "编辑业务", -1);
});

var _hoisted_2 = {
  class: "dialog-footer"
};
var _hoisted_3 = {
  class: "dialog-footer"
};
import { ref, reactive, watchEffect } from 'vue';
import userMemberSearch from './userMemberSearch.vue';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  props: {
    detailData: {
      type: Object,
      defaultValue: {}
    },
    visible: Boolean,
    showSRETree: Boolean,
    corporationId: String
  },
  emits: ['closeDialog', 'updateList'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var formRef = ref();
    var confirmDisabled = ref(false);
    var validateFormData = reactive({
      busiName: '',
      userList: []
    });
    var dialogVisible = ref(props.visible);

    var validateBusiName = function validateBusiName(rule, value, callback) {
      var pattern1 = new RegExp("^[0-9\u4E00-\u9FA5a-zA-Z_]{1,}$");

      if (value && !pattern1.test(value)) {
        confirmDisabled.value = true;
        callback(new Error('不可出现中英文字母+数字+下划线外的其他字符'));
      } else {
        confirmDisabled.value = false;
        callback();
      }
    };

    var rules = reactive({
      busiName: [{
        validator: validateBusiName,
        trigger: ['blur', 'change']
      }]
    });
    watchEffect(function () {
      var _props$detailData, _props$detailData2, _props$detailData2$bu;

      dialogVisible.value = props.visible;
      validateFormData.busiName = (_props$detailData = props.detailData) === null || _props$detailData === void 0 ? void 0 : _props$detailData.busiName;
      validateFormData.userList = (_props$detailData2 = props.detailData) === null || _props$detailData2 === void 0 ? void 0 : (_props$detailData2$bu = _props$detailData2.busiMemberVOList) === null || _props$detailData2$bu === void 0 ? void 0 : _props$detailData2$bu.map(function (item) {
        return {
          user_name: item.userName,
          user_id: item.userId
        };
      });
    });

    var handleDialogClose = function handleDialogClose() {
      emits('closeDialog');
    };

    var saveHandler = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(formEl) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (formEl) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                formEl.validate( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
                    var _validateFormData$use, _props$detailData3, _props$detailData4, _props$detailData5, _data$data, data, _data$data2;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!valid) {
                              _context.next = 8;
                              break;
                            }

                            console.log('submit!');
                            _context.next = 4;
                            return CompanyService.updateBusinessInfo({
                              adminUserIdList: (_validateFormData$use = validateFormData.userList) === null || _validateFormData$use === void 0 ? void 0 : _validateFormData$use.map(function (item) {
                                return item.user_id;
                              }),
                              busiId: (_props$detailData3 = props.detailData) === null || _props$detailData3 === void 0 ? void 0 : _props$detailData3.busiId,
                              busiName: validateFormData.busiName,
                              sreBusiIdPath: props.showSRETree ? (_props$detailData4 = props.detailData) === null || _props$detailData4 === void 0 ? void 0 : _props$detailData4.sreBusiIdPath : null,
                              sreBusiNamePath: props.showSRETree ? (_props$detailData5 = props.detailData) === null || _props$detailData5 === void 0 ? void 0 : _props$detailData5.sreBusiNamePath : null
                            });

                          case 4:
                            data = _context.sent;

                            if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                              emits('updateList');
                              handleDialogClose();
                            } else {
                              ElMessage({
                                message: data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.msg,
                                type: 'error'
                              });
                            }

                            _context.next = 10;
                            break;

                          case 8:
                            console.log('error submit!');
                            return _context.abrupt("return", false);

                          case 10:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function saveHandler(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    var updateUserList = function updateUserList(list) {
      validateFormData.userList = list;
    };

    return function (_ctx, _cache) {
      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return dialogVisible.value = $event;
        }),
        width: 736,
        "show-close": false,
        "before-close": handleDialogClose,
        "custom-class": "custom-modal add-busi-modal"
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "title"
          }, [_hoisted_1, _createElementVNode("i", {
            class: "iconfont iconclose-line",
            onClick: handleDialogClose
          })])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
            class: "btn-item cancel-btn",
            onClick: handleDialogClose
          }, "取消"), _createElementVNode("div", {
            class: _normalizeClass(['btn-item confirm-btn', {
              'btn-item-disabled': confirmDisabled.value
            }]),
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return saveHandler(formRef.value);
            })
          }, " 确认修改 ", 2)])])];
        }),
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "label-width": "125px",
            ref_key: "formRef",
            ref: formRef,
            model: _unref(validateFormData),
            rules: _unref(rules)
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "业务英文标识"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(__props.detailData && __props.detailData.busiCode), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "业务名称",
                prop: "busiName",
                rules: [{
                  required: true,
                  message: '业务名称不能为空',
                  trigger: ['blur', 'change']
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    modelValue: _unref(validateFormData).busiName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(validateFormData).busiName = $event;
                    }),
                    maxlength: "20",
                    placeholder: "支持输入中英文字符+数字+下划线，最长20字符"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "业务管理员",
                prop: "userList",
                rules: [{
                  required: true,
                  message: '业务管理员不能为空'
                }]
              }, {
                default: _withCtx(function () {
                  return [_createVNode(userMemberSearch, {
                    userSelectedList: _unref(validateFormData).userList,
                    corporationId: __props.corporationId,
                    onUpdateUserList: updateUserList
                  }, null, 8, ["userSelectedList", "corporationId"])];
                }),
                _: 1
              }), __props.showSRETree ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "关联SRE业务树"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(__props.detailData && __props.detailData.sreBusiNamePath), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true), __props.showSRETree ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "关联SRE业务树ID"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(__props.detailData && __props.detailData.sreBusiIdPath), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["model", "rules"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});